<template>
  <div class="all">
    <el-form label-width="130px"
             :model="dataForm"
             :rules="rules"
             ref="ruleForm">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="客户编码">
            <el-input v-model="dataForm.companyCode"
                      placeholder="客户编码"
                      :disabled="true"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户简称"
                        prop="companyShortName">
            <el-input v-model="dataForm.companyShortName"
                      placeholder="客户简称"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="客户名称"
                        prop="companyName">
            <el-input v-model="dataForm.companyName"
                      placeholder="客户名称"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <!-- todo -->
          <el-form-item label="所属行业">
            <el-select v-model="dataForm.wqe"
                       style="width: 100%;"
                       placeholder="所属行业">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="等级">
            <el-select v-model="dataForm.level"
                       style="width: 100%;"
                       placeholder="等级">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="企业性质">
            <el-select v-model="dataForm.nature"
                       style="width: 100%;"
                       placeholder="企业性质">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业地址"
                        prop="dizhi">
            <el-select v-model="dataForm.dizhi.provinceId"
                       style="width: 30%;float:left"
                       placeholder="省">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="dataForm.dizhi.cityId"
                       style="width: 30%;float:left;margin-left:5%"
                       placeholder="市">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="dataForm.dizhi.areaId"
                       style="width: 30%;float:left;margin-left:5%"
                       placeholder="区">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="dataForm.dizhi.address"
                      maxlength="50"
                      placeholder="详细地址：如街道，道路，园区门牌号等"
                      style="width: 100%;margin-top:10px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="法人代表">
            <el-input v-model="dataForm.legaPerson"
                      placeholder="法人代表"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户类型"
                        prop="companyType">
            <el-select v-model="dataForm.companyType"
                       style="width: 100%;"
                       placeholder="客户类型">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="注册资金">
            <el-select v-model="dataForm.registeredCapital"
                       style="width: 100%;"
                       placeholder="注册资金">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规模">
            <el-select v-model="dataForm.scale"
                       style="width: 100%;"
                       placeholder="规模">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="状态"
                        prop="enableStatus">
            <el-select v-model="dataForm.enableStatus"
                       multiple
                       collapse-tags
                       style="width: 100%;"
                       placeholder="状态">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册时间"
                        prop="registerTime">
            <el-date-picker v-model="dataForm.registerTime"
                            style="width: 100%;"
                            type="date"
                            placeholder="注册时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="所属组织"
                        prop="organize">
            <el-select v-model="dataForm.organize"
                       multiple
                       collapse-tags
                       style="width: 100%;"
                       placeholder="所属组织">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="简介">
            <el-input type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="dataForm.synopsis">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="企业主页">
            <el-input v-model="dataForm.companyPages"
                      placeholder="企业主页"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主联系人"
                        prop="contacts">
            <el-input v-model="dataForm.contacts"
                      placeholder="主联系人"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="座机">
            <el-input v-model="dataForm.landline"
                      placeholder="座机"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="传真">
            <el-input v-model="dataForm.fax"
                      placeholder="传真"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <!-- todo -->
          <el-form-item label="移动电话"
                        prop="mobile">
            <el-input v-model="dataForm.mobile"
                      placeholder="移动电话"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱">
            <el-input v-model="dataForm.mail"
                      placeholder="邮箱"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="dataForm.basicInfoRemarks">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        value: '1',
        value1: [],
        dizhi: {}
      },
      rules: {
        companyShortName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        companyType: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        enableStatus: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        registerTime: [
          { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        organize: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '必填项不能为空', trigger: 'blur' }
        ]
      },
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ]
    }
  },
  methods: {
    save () {
      let flag = null
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          flag = true
        } else {
          flag = false
        }
      })
      return flag
    }
  },
  components: {
  }
}
</script>
